// extracted by mini-css-extract-plugin
module.exports =  {"ecom-header":"Y5s1UQ","ecomHeader":"Y5s1UQ"};